import { Platform } from 'quasar';
import { boot } from 'quasar/wrappers';
import OneSignal from 'src/../src-capacitor/node_modules/onesignal-cordova-plugin';

export const DEFAULT_LOG_LEVEL = 6;
export const DEFAULT_VISUAL_LOG_LEVEL = 0;

export function OneSignalInit(): void {
  OneSignal.setLogLevel(DEFAULT_LOG_LEVEL, DEFAULT_VISUAL_LOG_LEVEL);

  const appId = Platform.is.android
    ? process.env.ONE_SIGNAL_APP_ID_ANDROID
    : process.env.ONE_SIGNAL_APP_ID_IOS;
  OneSignal.setAppId(appId as string);

  OneSignal.setNotificationOpenedHandler(function (jsonData) {
    console.log('notificationOpenedCallback: ' + JSON.stringify(jsonData));
  });

  OneSignal.promptForPushNotificationsWithUserResponse(function (accepted) {
    console.log(`User accepted notifications: ${String(accepted)}`);
  });
}

export default boot(({}) => {
  if (!Platform.is.capacitor) return;

  OneSignalInit();
});
